import { __decorate } from "tslib";
import { debounce } from 'lodash';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AddConfirmModal from './AddConfirmModal.vue';
let Products = class Products extends Vue {
    getImage(img) {
        return img?.galleryBlob.originalUrl;
    }
    submit(product) {
        const vm = this;
        if (vm.addedProducts.length > 0) {
            const appName = [...new Set(vm.addedProducts.map((obj) => obj.appName))];
            if (!appName.includes(product.appName)) {
                vm.validate = true;
                vm.product = product;
                return;
            }
        }
        this.$emit('add', product);
    }
    async confirm() {
        const vm = this;
        this.$emit('modalConfirm', vm.product);
        vm.validate = false;
    }
    cancel() {
        this.validate = false;
    }
    remove(product) {
        this.$emit('remove', product);
    }
    filterProductsByAppName() {
        this.$emit('filterByAppName', this.selectedAppName);
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], Products.prototype, "products", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], Products.prototype, "addedProducts", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], Products.prototype, "storeNames", void 0);
Products = __decorate([
    Component({
        data() {
            return {
                selectedAppName: 'All Merchants',
                filteredProducts: [],
                storeIcon: require('@/assets/images/store.svg'),
                shoppingBagIcon: require('@/assets/images/shopping-bag.svg'),
                validate: false,
                product: {},
            };
        },
        components: {
            AddConfirmModal,
        },
        methods: {
            // eslint-disable-next-line
            debounceSearch: debounce(function (text) {
                this.$emit('filterByProductName', text);
            }, 500),
        },
    })
], Products);
export default Products;
